/**
 * Secure card details are owner-only. Both ids must be resolved before an
 * equality match can grant access so loading or partial legacy data fails
 * closed instead of treating `undefined === undefined` as ownership.
 */
export const isViewerCardOwner = (
  ownerId: string | undefined,
  viewerId: string | undefined,
): boolean =>
  ownerId !== undefined && viewerId !== undefined && ownerId === viewerId
